import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Button from '@material-ui/core/Button';
import _ from 'lodash';
import Switch from '@material-ui/core/Switch';
import {
  companyStatus,companyDetail
} from '../../../../appRedux/actions/companiesAction';
import {
   getCompnay,
   getStates,
   accountingsoftware,
   payrollsoftware,
   deleteCompany,
} from '../../../../appRedux/actions/companiesAction';
import {
    AccountTypes,
    CompanyAccountTypes,
    CompanyTransactionTypes,
    TransactionTypes
} from '../../../../appRedux/actions/accountAction';
import CircularProgress from "../../../../components/CircularProgress";
import EditCompanyForm from '../../../../Forms/EditCompanyForm';
import DeleteCompanyForm from '../../../../Forms/DeleteCompanyForm';
import EditCompanyAccountsForm from '../../../../Forms/EditCompanyAccountsForm';
import EditCompanyWagesSettingForm from "../../../../Forms/EditCompanyWagesSetting";
import './CompanyDetailPage.css';

function displayValue(value) {
  if (value === null || value === undefined || value === '') {
    return '—';
  }
  return value;
}

function DetailRow({ label, children }) {
  return (
    <div className="company-detail-row">
      <span className="company-detail-label">{label}</span>
      <span className="company-detail-value">{children}</span>
    </div>
  );
}

class CompanyDetailPage extends Component {

    constructor(props) {
      super();
      this.state = {
        company:'',
        loading:true,
        isEdit: false,
        isDel: false,
        isEditAcc:false,
        isEditWages:false,
        accountingSoft: [],
        payrollSoft: [],
        states: [],
        accountTypes:[],
        transctionTypes:[],
        companyAccountTypes:[],
        companyTransactionTypes:[],
      };
    }

    componentDidMount() {
       let user = JSON.parse(localStorage.getItem('userData'));
        let companyId = user.companyId;
        this.props.getCompnay(companyId);
        this.props.getStates();
        this.props.accountingsoftware();
        this.props.payrollsoftware();
        this.props.AccountTypes();
        // this.props.companyDetail();
        this.props.TransactionTypes();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.states!==undefined && nextProps.states !== this.props.states) {
            this.setState({states:nextProps.states});
        }  else  if (nextProps.accountingSoft!==undefined && nextProps.accountingSoft !== this.props.accountingSoft) {
            this.setState({ accountingSoft:nextProps.accountingSoft});
        } else  if (nextProps.payrollSoft !==undefined && nextProps.payrollSoft !== this.props.payrollSoft) {
            this.setState({ payrollSoft:nextProps.payrollSoft});
        }  else  if (nextProps.accountTypes!==undefined && nextProps.accountTypes !== this.props.accountTypes) {
            this.setState({ accountTypes:nextProps.accountTypes.data});
        } else  if (nextProps.tranactionTypes!==undefined && nextProps.tranactionTypes !== this.props.tranactionTypes) {
            this.setState({ transctionTypes:nextProps.tranactionTypes.data});
        }  else  if (nextProps.company !==undefined && nextProps.company !== this.props.company) {
            this.setState({ loading: false , company:nextProps.company});
        } else if (nextProps.companyAccountTypes !== undefined && nextProps.companyAccountTypes !== this.props.companyAccountTypes) {

          this.setState({ companyAccountTypes:nextProps.companyAccountTypes.data});

        } else if(nextProps.companyTransactionTypes!==undefined && nextProps.companyTransactionTypes !== this.props.companyTransactionTypes) {

          this.setState({ isEdit:true,getAcc:false, companyTransactionTypes:nextProps.companyTransactionTypes.data});
        }
        if (nextProps.reload) {
          this.setState({ loading: false }, () => {
              this.props.companyDetail();
          });
      };
        
    }

     handleDelete = () => {

        this.setState({ isEdit: false, isEditAcc:false, isDel: true, isAdd: false });
    }

     handleDelModel = (record) => {
        var id = record.companyId;
        var data = this.props.company;
            this.setState({
                isDel: true, iAdd: false,
                CompanyId: id,
                selectedCompany: record,
            });
    }


    handleEditModel = (record) => {

        var id = record.companyId;

        this.props.CompanyAccountTypes(id);
        this.props.CompanyTransactionTypes(id);
        this.setState({
          CompanyId: id,
          selectedCompany: record,
         });

        if(this.state.getAcc === false) {
              this.setState({
                isEdit: true, iAdd: false, isDel: false
            });
        }
    }

     handleEditCancel = () => {
        this.setState({ isEdit: false ,  isEditAcc:false});
    }
    handleDelCancel = () => {
        this.setState({ isDel: false, isEditAcc:false, isEdit: false,isEditWages:false });
    }
    handleEditSave = (state) => {
      this.setState({
          isEditAcc: state
      });
    }
     handleDelSave = (state) => {
        this.setState({
            isDel: state
        });
    }
    accountStatusChange = (event) => {
      let isChecked = event.target.checked;
      this.setState(prevState => ({
        company: {
          ...prevState.company,
          isActive: isChecked
        }
      }),()=>{
        let data = {
          "companyId": this.state.company.companyId,
          "status": isChecked
      };
        this.props.companyStatus(data)
        
      }
      
      );
      
      
  }


    ShowWages = () =>{      
      this.setState({isEdit:false,isEditAcc:false,isEditWages:true})
    }

  render() {
    const { company, accountingSoft, payrollSoft } = this.state;
    var accountingSoftware = "";
    if(accountingSoft && accountingSoft.length>0)
    {
        var acc_o = _.find(accountingSoft, {id:company.accountingSoftwareId});
        if(acc_o)
          accountingSoftware = acc_o.name;
    }

    var payrollsoftware = "";
    if(payrollSoft && payrollSoft.length>0)
    {
        var acc_o = _.find(payrollSoft, {id:company.payrollSoftwareId});
        if(acc_o)
          payrollsoftware = acc_o.name;
    }



  return (
      <div className="company-detail-page">

  <EditCompanyForm
        handleSave={this.handleEditSave}
        visible={this.state.isEdit}
        states={this.state.states}
        accountingSoft={this.state.accountingSoft}
        payrollSoft={this.state.payrollSoft}
        handleCancel={this.handleEditCancel}
        selectedItem={this.state.selectedCompany}
        nextForm={(fstep) => this.setState({
             isEditAcc: true, isAdd: false,
             isEdit: false, isDel: false,
             AccNext:fstep                
            })}
        ShowWages={this.ShowWages}
    />
   <DeleteCompanyForm
      handleSave={this.handleDelSave}
      visible={this.state.isDel}
      handleCancel={this.handleDelCancel}
      selectedItem={this.state.selectedCompany} />

  {this.state.isEditWages && <EditCompanyWagesSettingForm
  handleDelCancel={this.handleDelCancel}>

  </EditCompanyWagesSettingForm>}

  { this.state.isEditAcc == true ? <EditCompanyAccountsForm
    handleSave={this.handleEditSave}
    visible={this.state.isEditAcc}
    AccNext={this.state.AccNext}
    handleDelete={this.handleDelete}
    accountingSoft={this.state.accountingSoft}
    payrollSoft={this.state.payrollSoft}
    transctionTypes={this.state.transctionTypes}
    accountTypes={this.state.accountTypes}
    companyAccountTypes={this.state.companyAccountTypes}
    companyTransactionTypes={this.state.companyTransactionTypes}
    handleCancel={() => this.setState({  isAcc: false, isEditAcc:false,isAdd: false, isEdit: false, isDel: false })}
    selectedItem={this.state.selectedCompany}
    handleBack={() => {
        this.setState({
            isAcc: false, isEditAcc:false,  isEdit: true
        })
    }}
    /> :'' }

  {this.state.loading ? (
          <div className="company-detail-loader">
            <CircularProgress />
          </div>
        ) : (
          <React.Fragment>
      <div className="company-detail-header">
          <h2 className="company-detail-title">Company Details Page</h2>
          <Button className="company-detail-edit" variant="contained" color="primary" onClick={() => this.handleEditModel(company)}>
                 Edit Company
             </Button>
      </div>
          <div className="company-detail-grid">
                <div className="company-detail-col">
                  <div className="company-detail-card">
                    <h3 className="company-detail-card-title">Company Information</h3>
                    <DetailRow label="Name">{displayValue(company.name)}</DetailRow>
                    <DetailRow label="Legal Address">{displayValue(company.address)}</DetailRow>
                    <DetailRow label="City">{displayValue(company.city)}</DetailRow>
                    <DetailRow label="State">{displayValue(company.state)}</DetailRow>
                    <DetailRow label="Zip">{displayValue(company.postalCode)}</DetailRow>
                    <DetailRow label="EIN Number">{displayValue(company.eiNnumber)}</DetailRow>
                    <DetailRow label="Religious Organization">{company.isReligeousOrganization ? 'Yes' : 'No'}</DetailRow>
                    <div className="company-detail-row">
                      <span className="company-detail-label">Active Status</span>
                      <span className="company-detail-value company-detail-status">
                        <Switch
                          color="default"
                          checked={company.isActive}
                          onChange={(e) => this.accountStatusChange(e)} />
                        <span className={company.isActive ? 'company-detail-status-text is-active' : 'company-detail-status-text is-inactive'}>
                          {company.isActive ? 'Active' : 'Inactive'}
                        </span>
                      </span>
                    </div>
                  </div>
                  <div className="company-detail-card">
                    <h3 className="company-detail-card-title">QuickBooks Sync Settings</h3>
                    <DetailRow label="Beginning Year">{displayValue(company.quickbooksDataSyncBeginningYear)}</DetailRow>
                    <DetailRow label="Ending Year">{displayValue(company.quickbooksDataSyncEndingYear)}</DetailRow>
                    <DetailRow label="Sync Frequency">{displayValue(company.syncFrequency)}</DetailRow>
                  </div>
                </div>
                 <div className="company-detail-col">
                  <div className="company-detail-card">
                    <h3 className="company-detail-card-title">Accounting Settings</h3>
                    <DetailRow label="Accounting Software">{displayValue(accountingSoftware)}</DetailRow>
                    <DetailRow label="Payroll Software">{displayValue(payrollsoftware)}</DetailRow>
                    <DetailRow label="Accounting Method">Accrual</DetailRow>
                    <DetailRow label="QB Company ID">{displayValue(company.realmID)}</DetailRow>
                    <DetailRow label="QB Company Name">{displayValue(company.name)}</DetailRow>
                    <DetailRow label="Full Service Bookkeeping">{company.isFullServiceBookkeeping ? 'Yes' : 'No'}</DetailRow>
                  </div>
                  <div className="company-detail-card">
                    <h3 className="company-detail-card-title">Contacts</h3>
                    <DetailRow label="Accounting Team Basecamp Email">{displayValue(company.mpwAccountantEmail)}</DetailRow>
                    <DetailRow label="Infusionsoft ContactId">{displayValue(company.infusionsoftContactId)}</DetailRow>
                  </div>
                  {/* {company.accountingMethod == "C" ? 'Cash' : 'Accrual'} */}
                 </div>
            </div>
          </React.Fragment>
        )}
    </div>
  );
 }
}


const mapStateToProps = (state) => {
    return {
        company: state.companyReducer.companyDeatils,
        reload: state.companyReducer.reload,
        states:state.companyReducer.states,
        accountingSoft:state.companyReducer.accountingSoftwares,
        payrollSoft:state.companyReducer.payrollSoftwares,
        accountTypes:state.accounts.accountTypes,
        tranactionTypes:state.accounts.tranactionTypes,
        companyAccountTypes:state.accounts.companyAccountTypes,
        companyTransactionTypes:state.accounts.companyTransactionTypes,
    }
}
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
         getCompnay,
         getStates,
         accountingsoftware,
         payrollsoftware,
         deleteCompany,
         AccountTypes,
        CompanyAccountTypes,
        CompanyTransactionTypes,
        TransactionTypes,
        companyStatus,
        companyDetail
    }, dispatch)
}
export default connect(mapStateToProps, mapDispatchToProps)(CompanyDetailPage);
